var exports = {
  "a": "x127c5a35--725271--balloon",
  "K": "x127c5a35--725271--icon",
};

module.exports = exports;
